var _path, _path2, _path3, _mask, _ellipse, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.79406 7.45869C3.33698 5.14417 5.14417 3.33698 7.45869 2.79406C9.13021 2.40198 10.8698 2.40198 12.5413 2.79406C14.8558 3.33698 16.663 5.14417 17.2059 7.4587C17.598 9.13021 17.598 10.8698 17.2059 12.5413C16.663 14.8558 14.8558 16.663 12.5413 17.2059C10.8698 17.598 9.13021 17.598 7.4587 17.2059C5.14418 16.663 3.33698 14.8558 2.79406 12.5413C2.40198 10.8698 2.40198 9.13021 2.79406 7.45869Z",
    fill: "white",
    fillOpacity: 0.15,
    stroke: "#9A9A9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 12.9173V9.58398V12.9173Z",
    fill: "white",
    fillOpacity: 0.15
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.9173V9.58398",
    stroke: "#9A9A9A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_1516_4357",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.99984,
    cy: 7.49935,
    rx: 0.833333,
    ry: 0.833333
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.99984,
    cy: 7.49935,
    rx: 0.833333,
    ry: 0.833333,
    fill: "white",
    fillOpacity: 0.15
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83317 7.49935C9.83317 7.4073 9.90779 7.33268 9.99984 7.33268V9.33268C11.0124 9.33268 11.8332 8.51187 11.8332 7.49935H9.83317ZM9.99984 7.33268C10.0919 7.33268 10.1665 7.4073 10.1665 7.49935H8.1665C8.1665 8.51187 8.98731 9.33268 9.99984 9.33268V7.33268ZM10.1665 7.49935C10.1665 7.5914 10.0919 7.66602 9.99984 7.66602V5.66602C8.98731 5.66602 8.1665 6.48683 8.1665 7.49935H10.1665ZM9.99984 7.66602C9.90779 7.66602 9.83317 7.5914 9.83317 7.49935H11.8332C11.8332 6.48683 11.0124 5.66602 9.99984 5.66602V7.66602Z",
    fill: "#9A9A9A",
    mask: "url(#path-4-inside-1_1516_4357)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.e80d4a3365b5eadbf30b269fec25d083.svg";
export { ForwardRef as ReactComponent };